
function genGetterFilter(listType) {
  return (state, getters, gState, gGetters) => {
    if (!state.filter.search) {
      return gGetters[`${listType}/features`]
    }
    if (state.filter.listType == listType) {
      return gGetters[`${listType}/filter`](state.filter)
    }
    return []
  }
}

function genGetterByGminaFilter(listType) {
  return (state, getters, gState, gGetters) => {
    let all = getters[listType]
    let byGmina = {}

    all.forEach(i => {
      let gminaId = i.properties.gmina_id;
      byGmina[gminaId] = byGmina[gminaId] || [];
      byGmina[gminaId].push(i)
    })

    return byGmina
  }
}

function genGetterShow(listType) {
  return state => {
    if (!state.filter.search) {
      return true
    }
    if (state.filter.listType == listType) {
      return true
    }
    return false
  }
}

export default {
  namespaced: true,
  state: {
    filter: {
      search: false,
    }
  },
  getters: {
    active: state => state.filter.search,
    filter: state => state.filter,

    tereny: genGetterFilter("tereny"),
    terenyByGmina: genGetterByGminaFilter("tereny"),
    hale: genGetterFilter("hale"),
    biura: genGetterFilter("biura"),
    inwestorzy: genGetterFilter("inwestorzy"),
    inwestorzyByGmina: genGetterByGminaFilter("inwestorzy"),

    terenyShow: genGetterShow("tereny"),
    haleShow: genGetterShow("hale"),
    biuraShow: genGetterShow("biura"),
    inwestorzyShow: genGetterShow("inwestorzy"),
  },
  mutations: {
    setFilter(state, filter) {
      if (filter === undefined) {
        throw "filter can not be undefined";
      }
      state.filter = filter;
      state.filter.search = true;
    },
    clearFilter(state) {
      state.filter = {
        search: false
      }
    }
  }
}
